<template>
  <div class="language-switcher" ref="switcherRef">
    <button
      class="language-switcher__button"
      @click="toggleMenu"
      :aria-expanded="isOpen"
      aria-haspopup="true"
      aria-label="Change language"
      type="button"
    >
      <span class="language-switcher__current">
        <span class="language-switcher__code">
          {{ currentLanguage.toUpperCase() }}
        </span>
      </span>
      <svg 
        class="language-switcher__icon"
        :class="{ 'language-switcher__icon--open': isOpen }"
        width="12" 
        height="12" 
        viewBox="0 0 12 12" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path 
          d="M2.5 4.5L6 8L9.5 4.5" 
          stroke="currentColor" 
          stroke-width="1.5" 
          stroke-linecap="round" 
          stroke-linejoin="round"
        />
      </svg>
    </button>
    
    <Transition name="language-dropdown">
      <ul
        v-if="isOpen"
        class="language-switcher__dropdown"
        role="menu"
      >
        <li
          v-for="lang in availableLanguages"
          :key="lang.code"
          class="language-switcher__item"
          role="none"
        >
          <button
            class="language-switcher__option"
            :class="{ 'language-switcher__option--active': lang.code === currentLanguage }"
            @click="switchLanguage(lang.code)"
            role="menuitem"
            type="button"
          >
            <span class="language-switcher__name">{{ lang.name }}</span>
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import useLanguageSwitcher from './LanguageSwitcher'

defineOptions({ name: 'LanguageSwitcher' })

const switcherRef = ref<HTMLElement | null>(null)

const {
  currentLanguage,
  isOpen,
  availableLanguages,
  toggleMenu,
  switchLanguage,
  closeMenu
} = useLanguageSwitcher()

const currentLanguageData = computed(() => 
  availableLanguages.find(l => l.code === currentLanguage.value)
)

// Close dropdown when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  if (switcherRef.value && !switcherRef.value.contains(event.target as Node)) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
